function isAbortError(error: unknown): boolean {
  if (error === null || typeof error !== "object") {
    return false;
  }

  return "name" in error && error.name === "AbortError";
}

export { isAbortError };
